import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { GuestCheckModalComponent } from '@shared/modals/guest-check-modal/guest-check-modal.component';
import { GuestCheckData } from '@shared/modals/guest-check-modal/shared/guest-check-data';
import { BaseStoreService } from '@shared/stores/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class GuestCheckModalStoreService extends BaseStoreService<GuestCheckData> {

  constructor(
    private ngbModal: NgbModal,
  ) {
    super();
  }

  show(data: GuestCheckData): NgbModalRef {
    this.current = data;

    return this.ngbModal.open(GuestCheckModalComponent, {
      size: 'lg',
    });
  }
}
